import { render, staticRenderFns } from "./audiences.vue?vue&type=template&id=9eb670f2"
import script from "./audiences.vue?vue&type=script&lang=js"
export * from "./audiences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports